"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const BaseButton_1 = __importDefault(require("./BaseButton"));
const clsx_1 = __importDefault(require("clsx"));
const IconButton = ({ icon, size = 'default', ...props }) => {
    const Icon = icon;
    return (react_1.default.createElement(BaseButton_1.default, Object.assign({}, props, { className: clsx_1.default('disabled:text-gray-200 text-gray-400 hover:text-gray-500 focus:text-gray-500 dark-hover:text-white focus:outline-none disabled:cursor-not-allowed transition duration-150 ease-in-out', size === 'small' ? 'p-1' : 'p-4') }),
        react_1.default.createElement(Icon, { className: size === 'small' ? 'w-4 h-4' : 'w-6 h-6' })));
};
exports.default = IconButton;
